import React, { useState } from 'react';
import { Box, Button, Typography, CircularProgress } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import LogoutIcon from '@mui/icons-material/Logout';
import { useAuth } from '../contexts/AuthContext';

/**
 * Dauerhaft sichtbarer Hinweis, dass gerade eine fremde Sicht angezeigt wird.
 * Ohne diesen Streifen wäre nicht erkennbar, wessen Sicht man sieht – und ein
 * Admin könnte glauben, Daten fehlten, obwohl nur gefiltert wird.
 */
function ImpersonationBanner() {
  const { user, stopImpersonation } = useAuth();
  const [leaving, setLeaving] = useState(false);

  if (!user?.impersonated_by) return null;

  const target = user.full_name || user.username;
  const role = user.role === 'client' ? 'Kunde' : 'interner Benutzer';

  const leave = async () => {
    setLeaving(true);
    await stopImpersonation();
  };

  return (
    <Box sx={{
      position: 'sticky', top: 0, zIndex: (t) => t.zIndex.appBar + 2,
      display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap',
      px: 2, py: 1, bgcolor: 'warning.main', color: 'warning.contrastText',
      borderBottom: '2px solid', borderColor: 'warning.dark',
    }}>
      <VisibilityIcon fontSize="small" />
      <Typography variant="body2" sx={{ fontWeight: 600 }}>
        Ansichtsmodus: Du siehst ROTIS als {target} ({role}).
      </Typography>
      <Typography variant="caption" sx={{ opacity: 0.9 }}>
        Nur Lesezugriff – Änderungen und Chat sind gesperrt.
      </Typography>
      <Button
        size="small"
        variant="contained"
        color="inherit"
        onClick={leave}
        disabled={leaving}
        startIcon={leaving ? <CircularProgress size={14} color="inherit" /> : <LogoutIcon />}
        sx={{ ml: 'auto', color: 'warning.dark', bgcolor: 'common.white' }}
      >
        Zurück zu meinem Konto
      </Button>
    </Box>
  );
}

export default ImpersonationBanner;
